
import { Vue } from "vue-class-component"; // 基本需要
import {
  dispatchPerfettoTraces,
  dispatchPerfettoMapData,
} from "@/store/performance/actions"; // 基本需要
import { store } from "@/store";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型

export default class TestReport extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public num = 0;
  public async mounted() {
    // let dataToSend = null;
    let scene = this.$route.query.scene_name
      ? this.$route.query.scene_name
      : "";
    let level: any = this.$route.query.level ? this.$route.query.level : "";
    let device_id = this.$route.query.device_id
      ? this.$route.query.device_id
      : "";
    let task_record_id = this.$route.query.task_record_id
      ? this.$route.query.task_record_id
      : "";
    const iframe: any = this.$refs.iframeDom;

    // let dataToSend = "这是从 Vue 父窗口发送的数据";

    // iframe.addEventListener("load", () => {
    //   // 在 iframe 加载完成后发送消息
    //   const contentWindow = iframe.contentWindow;
    //   contentWindow.postMessage(
    //     {
    //       data: 2,
    //     },
    //     "*" // 请将 * 替换为实际的 iframe 域名，以增强安全性
    //   );
    // });
    // const dataToSend = await this.fetchData();
    // const contentWindow:any = (this.$refs.iframeDom as any).contentWindow;
    //         contentWindow.postMessage(
    //     {
    //       data: dataToSend,
    //     },
    //     "*" // 请将 * 替换为实际的 iframe 域名，以增强安全性
    //   );
    // 可能是用按钮点延时比较高 或者开启settimeout 应该设个时间也可以 但是如果直接等待load渲染完成直接传就会导致接收不到应该是iframe机制问题
    let b = (this as any).$message({
      //Message 消息提示
      message: "加载中...",
      showClose: true,
      duration: 0,
    });
    await this.$nextTick(() => {
      this.btn();
    });

    b.close();
    // await dispatchPerfettoTraces(store,{
    // project:Number(this.$route.query.project),
    // task_record_id:task_record_id,
    // device_id:device_id,
    // scene_name:scene,
    // level:decodeURIComponent(level),

    // }).then((res)=>{
    //   if(res){
    //     console.log(res)
    //     // setInterval(()=>{
    //     //   console.log(res)
    //     //   this.num++
    //     // },1000)
    //      iframe.addEventListener('load', () => {

    //   // 在iframe加载完成后发送消息
    //   const contentWindow = iframe.contentWindow;
    //   console.log(res)
    //   contentWindow.postMessage(
    //     {
    //       data:2
    //     },
    //     '*'
    //   );
    // });
    //   }
    // })

    // 为iframe添加load事件监听器
  }
  public async fetchData() {
    let scene = this.$route.query.scene_name
      ? this.$route.query.scene_name
      : "";
    let level: any = this.$route.query.level ? this.$route.query.level : "";
    let device_id = this.$route.query.device_id
      ? this.$route.query.device_id
      : "";
    let date = this.$route.query.date ? this.$route.query.date : "";
    let version = this.$route.query.version ? this.$route.query.version : "";
    console.log(level);
    const response = await dispatchPerfettoTraces(store, {
      project: Number(this.$route.query.project),
      date: date,
      version: version,
      device_id: device_id,
      scene_name: scene,
      level: level,
    });
    return response;
  }
  public level_type(type) {
    if (type == 1) {
      return "高画质";
    }
    if (type == 2) {
      return "中画质";
    }
    if (type == 3) {
      return "低画质";
    }
  }
  public async fetchScopeData() {
    let scene = this.$route.query.scene_name
      ? this.$route.query.scene_name
      : "";
    let level: any = this.$route.query.level ? this.$route.query.level : "";
    let device_id = this.$route.query.device_id
      ? this.$route.query.device_id
      : "";
    let date = this.$route.query.date ? this.$route.query.date : "";
    let version = this.$route.query.version ? this.$route.query.version : "";
    const response = await dispatchPerfettoMapData(store, {
      project: Number(this.$route.query.project),
      date: date,
      version: version,
      device_id: device_id,
      scene_name: scene,
      level: level,
    });
    return response;
  }
  public async btn() {
    const dataToSend = await this.fetchData();
    // const dataToSend1 = await this.fetchScopeData();
    const contentWindow: any = (this.$refs.iframeDom as any).contentWindow;
    contentWindow.postMessage(
      {
        data: dataToSend,
      },
      "*" // 请将 * 替换为实际的 iframe 域名，以增强安全性
    );
    //      const contentWindow1:any = (this.$refs.iframeDom1 as any).contentWindow;
    //       contentWindow1.postMessage(
    //   {
    //     data: dataToSend1,
    //   },
    //   "*" // 请将 * 替换为实际的 iframe 域名，以增强安全性
    // );
  }
  //  async loadFlamegraphData() {
  //   const response = await fetch('path/to/flamegraph/data.json')
  //   const json = await response.json()
  //   this.flamegraphData = json
  // }
  // public speedscopeViewer:any
  // async initSpeedscope() {
  //   this.speedscopeViewer = new Viewer()
  //   (this.$refs.speedscopeContainer as any).appendChild(this.speedscopeViewer.iframe)
  //   const importedProfile = importFromJson(JSON.stringify({type: 'flamegraph', value: this.flamegraphData}))
  //   this.speedscopeViewer.setProfile(importedProfile)
  // }
}
